import setTicketDiscountScreen from './setTicketDiscountScreen';
import { NamedDiscountType, Permission, NamedDiscountDTO, Res, DiscountMode } from 'core/api';
import * as SalesStore from '../SalesStore';
import { SessionProvider } from 'core/infrastructure';
import * as Images from 'pos/Images';
import { RestaurantFacade } from 'pos/facades';
import { Command } from 'pos/common';

declare global {
	interface CommandType {
		setTicketDiscount: () => Promise<Result>
	}
}

// NO se le asigna permisos porque dependiendo de lo que vaya a hacer se debe aplicar o no.
Command.register('setTicketDiscount', 'NO_PRECONDITION', async (): Promise<Result> => {
	const ticket = SalesStore.getTicket();
	const discounts = await RestaurantFacade.getNamedDiscountsByUser(ticket.Id, NamedDiscountType.Ticket);

	if (discounts.some(x => x)) {
		const canRemove = SessionProvider.hasPermission(Permission.Ticket_SetTicketDiscountPercentage) || discounts.some(x => x.IsAllowed);
		const removeDiscount: NamedDiscountDTO = {
			Id: 0,
			Name: Res.Msg.MSG_REMOVE_NAMED_DISCOUNT(),
			Code: '{AC0CF5AE-1638-40ED-A8EB-86B0217C36D6}',
			IsAllowed: canRemove,
			RequiresAuthorization: false,
			RequiresAuthorizerAuthentication: false,
			Style: {
				Text: Res.Msg.MSG_REMOVE_NAMED_DISCOUNT(),
				BackColor: '',
				ImageId: Images.DB_REMOVE_DISCOUNT
			},
			RateOrCash: 0,
			Mode: DiscountMode.Rate
		};
		const allDiscounts = [removeDiscount, ...discounts];

		const selected = allDiscounts.find(x => x.Id === ticket.AppliedDiscountId) || null;

		return setTicketDiscountScreen(ticket, allDiscounts, selected);
	} else {
		// Sin descuentos con nombre sólo se puede aplicar el descuento manual
		return setTicketDiscountScreen(ticket);
	}

});
